import styled from 'styled-components'

const FlexSpacer = styled.span`
  flex: 1 1 auto;
`

export default FlexSpacer
